import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

// [获取用户心愿列表] http://wiki.xunlei.cn/pages/viewpage.action?pageId=132031130
export const get_my_wish_list = createAsyncThunk(
  'Wish/live/facetime/get_my_wish_list',
  async (arg: {need_mid: number; seed_mid: number}, store: any) => {
    const resp = await http.post<HiyaRes<DataInfo>>(
      '/live/facetime/get_wish_list',
      {
        ...store.getState().env.deviceinfo,
        ...store.getState().env.otherInfo,
        ...arg,
      }
    )
    return resp.data.data
  }
)

// [获取用户心愿列表] http://wiki.xunlei.cn/pages/viewpage.action?pageId=132031130
export const get_peer_wish_list = createAsyncThunk(
  'Wish/live/facetime/get_peer_wish_list',
  async (arg: {need_mid: number; seed_mid: number}, store: any) => {
    const resp = await http.post<HiyaRes<DataInfo>>(
      '/live/facetime/get_wish_list',
      {
        ...store.getState().env.deviceinfo,
        ...store.getState().env.otherInfo,
        ...arg,
      }
    )
    return resp.data.data
  }
)

// [添加心愿] http://wiki.xunlei.cn/pages/viewpage.action?pageId=132031148
export const add_wish = createAsyncThunk(
  'Wish/live/facetime/add_wish',
  async (arg: {gift_id: number; num: number; promise_id}, store: any) => {
    const resp = await http.post<HiyaRes<any>>(
      '/live/facetime/add_wish',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// [删除心愿] http://wiki.xunlei.cn/pages/viewpage.action?pageId=132031156
export const del_wish = createAsyncThunk(
  'Wish/live/facetime/del_wish',
  async (arg: {wish_id: number}, store: any) => {
    const resp = await http.post<HiyaRes<any>>('/live/facetime/del_wish', {
      ...store.getState().env.deviceinfo,
      ...arg,
    })
    return resp.data.data
  }
)

// [分享心愿] http://wiki.xunlei.cn/pages/viewpage.action?pageId=135991608
export const wish_share = createAsyncThunk(
  '/live/facetime/wish_share',
  async (arg: {from: string; peer_id: number; wish_id: number}, store: any) => {
    const resp = await http.post<HiyaRes<any>>(
      '/live/facetime/wish_share',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 举报心愿] http://wiki.xunlei.cn/pages/viewpage.action?pageId=132031148
export const complaint_wish = createAsyncThunk(
  'Wish/live/facetime/add_wish_complaint',
  async (
    arg: {reported_id: number; wish_id: number; text: string},
    store: any
  ) => {
    const resp = await http.post<HiyaRes<any>>(
      '/live/facetime/add_wish_complaint',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      }
    )
    return resp.data.data
  }
)

// [我完成的心愿单] http://wiki.xunlei.cn/pages/viewpage.action?pageId=132031172
export const finished_wish_list = createAsyncThunk(
  'Wish/live/facetime/finished_wish_list',
  async (arg: any, store: any) => {
    const resp = await http.post<HiyaRes<{list: HelpWishInfo[]}>>(
      '/live/facetime/finished_wish_list',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      }
    )
    return resp.data.data
  }
)

// [我助力的心愿单] http://wiki.xunlei.cn/pages/viewpage.action?pageId=132031158
export const help_wish_list = createAsyncThunk(
  'Wish/live/facetime/help_wish_list',
  async (arg: any, store: any) => {
    const resp = await http.post<HiyaRes<{list: HelpWishInfo[]}>>(
      '/live/facetime/help_wish_list',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      }
    )
    return resp.data.data
  }
)

// [活动状态] http://wiki.xunlei.cn/pages/viewpage.action?pageId=135988745
export const wish_rank_time = createAsyncThunk(
  '/live/facetime/wish_rank_time',
  async (arg, store: any) => {
    const resp = await http.post<HiyaRes<IRankTime>>(
      '/live/facetime/wish_rank_time',
      {
        ...store.getState().env.deviceinfo,
        // ...arg,
      }
    )
    return resp.data.data
  }
)

// [用户榜单] http://wiki.xunlei.cn/pages/viewpage.action?pageId=135988748
export const wish_rank_user_info = createAsyncThunk(
  '/live/facetime/wish_rank_user_info',
  async (arg, store: any) => {
    const resp = await http.post<HiyaRes<{rank_info: RankItem}>>(
      '/live/facetime/wish_rank_user_info',
      {
        ...store.getState().env.deviceinfo,
        // ...arg,
      }
    )
    return resp.data.data
  }
)

// [全部榜单] http://wiki.xunlei.cn/pages/viewpage.action?pageId=135988743
export const wish_rank_list = createAsyncThunk(
  '/live/facetime/wish_rank_list',
  async (arg, store: any) => {
    const resp = await http.post<HiyaRes<{list: RankItem[]}>>(
      '/live/facetime/wish_rank_list',
      {
        ...store.getState().env.deviceinfo,
        // ...arg,
      }
    )
    return resp.data.data
  }
)

interface IRankTime {
  status: number // 活动状态: 0 未开启，1 开启， 2 结束
  time_stamp: number // 活动倒计时
  gift_img: string
  gift_name: string
  time_str: string
  reward_img: string
  is_all_gift: boolean // 是否所有心愿礼物
}

export interface RankItem {
  rank: number
  score: number
  user_info: {
    mid: number
    name: string
    avatar: string
  }
}

interface HelpWishInfo {
  user_info: UserInfo // 用户信息
  promise_text: string // 承诺文案
  threshold: number // 完成数量
  gift_info: GiftInfo // 礼物信息
  wish_id: number // 心愿id
}

interface GiftInfo {
  goods_id: number // 礼物id
  name: string // 名称
  // popup_icon: string // 缩略图
  // desc_icon: string // 详情图
  url: string // 图片
  price: number // 价格
}

interface PromiseInfo {
  id: number // 承诺id
  text: string // 承诺文案
  user_info: UserInfo // 用户信息
  gift_info: GiftInfo // 礼物信息
}

interface UserInfo {
  mid: number // 用户id
  name: string // 名称
  avatar: string // 头像
}

interface WishInfo {
  promise_text: string // 承诺文案
  num: number // 当前数量
  threshold: number // 完成数量
  gift_info: GiftInfo // 礼物信息
  is_finished: boolean // 是否完成
  wish_id: number // 心愿id
  promise_info: PromiseInfo // 承诺信息
}

interface DataInfo {
  wish_list: WishInfo[] | null // 心愿单列表
  promise_list: PromiseInfo[] // 承诺列表
  gifts_list: GiftInfo[] // 礼物列表
  send_nums: number[] // 赠送数量
  url: string // 跳转链接
  user_info: UserInfo // 用户信息
}

export interface InitialStateType {
  myWish: Partial<DataInfo>
  peerWish: Partial<DataInfo>
  finishedList: HelpWishInfo[]
  helpList: HelpWishInfo[]
  rankTime: Partial<IRankTime>
  rankMy: Partial<RankItem>
  rankList: RankItem[]
}

const initialState: InitialStateType = {
  myWish: {},
  peerWish: {},
  finishedList: [],
  helpList: [],
  rankTime: {},
  rankMy: {},
  rankList: [],
}

export const WishListSlice = createSlice({
  name: 'WishList',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(get_my_wish_list.fulfilled, (state, action) => {
      Object.assign(state, {myWish: {...action.payload}})
    })

    builder.addCase(get_peer_wish_list.fulfilled, (state, action) => {
      Object.assign(state, {peerWish: {...action.payload}})
    })

    builder.addCase(finished_wish_list.fulfilled, (state, action) => {
      Object.assign(state, {finishedList: action.payload.list || []})
    })

    builder.addCase(help_wish_list.fulfilled, (state, action) => {
      Object.assign(state, {helpList: action.payload.list || []})
    })

    builder.addCase(wish_rank_time.fulfilled, (state, action) => {
      Object.assign(state, {rankTime: {...action.payload}})
    })
    builder.addCase(wish_rank_user_info.fulfilled, (state, action) => {
      Object.assign(state, {rankMy: {...action.payload.rank_info}})
    })
    builder.addCase(wish_rank_list.fulfilled, (state, action) => {
      Object.assign(state, {rankList: action.payload.list})
    })
  },
})
export default WishListSlice.reducer
export const WishListActions = WishListSlice.actions

export const useMyWishListDataState = () => {
  const data = useSelector((state) => {
    return state.WishList.myWish
  })
  return data
}
export const usePeerWishListDataState = () => {
  const data = useSelector((state) => {
    return state.WishList.peerWish
  })
  return data
}

export const useFinishedListDataState = () => {
  const data = useSelector((state) => {
    return state.WishList.finishedList
  })
  return data
}

export const useHelpListDataState = () => {
  const data = useSelector((state) => {
    return state.WishList.helpList
  })
  return data
}
export const useWishListDataState = () => {
  const data = useSelector((state) => {
    return state.WishList
  })
  return data
}
